import getAPI from "@API/index";

export function downloadFileByPath(href: string, name: string) {
  const link = document.createElement("a");
  link.setAttribute("download", name);
  link.href = href;
  document.body.appendChild(link);
  link.click();
}

export async function downloadFile(
  endpoint: string,
  throwOnError = false
): Promise<void> {
  try {
    const _fileSettings = { name: "" };
    const blob = await getAPI().request({
      url: endpoint,
      responseType: "blob",
      _fileSettings,
    });

    const href = URL.createObjectURL(blob);
    downloadFileByPath(href, _fileSettings.name);
    URL.revokeObjectURL(href);
  } catch (e) {
    if (throwOnError) {
      throw e;
    }
  }
}

export async function getAllCustomersWithClients(): Promise<any[]> {
  try {
    const response = await getAPI().request({
      method: "get",
      url: "/api/Customer",
    });
    return response as any[];
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
}

export async function updateCustomerLeadRole(
  customerId: string,
  role: "Standard" | "LeadGenerator" | "LeadReceiver",
  leadIntegrationKey: string | null = null
): Promise<void> {
  const response = await getAPI().request<{ success: boolean; message?: string }>({
    method: "put",
    url: `/api/Customer/${customerId}/lead-role`,
    data: { role, leadIntegrationKey },
  });
  if (response && response.success === false) {
    throw new Error(response.message || "Не удалось изменить роль клиента");
  }
}

export async function getLeadIntegrations(): Promise<
  Array<{ key: string; name: string }>
> {
  const response = await getAPI().request<{
    success: boolean;
    data: Array<{ key: string; name: string }>;
  }>({
    method: "get",
    url: "/api/Lead/integrations",
  });
  return response?.data ?? [];
}

export async function getAllFinDataRequests(): Promise<any[]> {
  try {
    const response = await getAPI().request({
      method: "get",
      url: "/api/FinDataRequest",
    });
    return response as any[];
  } catch (error) {
    console.error("Error fetching FinDataRequests:", error);
    throw error;
  }
}
